import { render, staticRenderFns } from "./fixedPrice.vue?vue&type=template&id=1436629b&scoped=true&"
import script from "./fixedPrice.vue?vue&type=script&lang=js&"
export * from "./fixedPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1436629b",
  null
  
)

export default component.exports